'use client';
import { useEffect, Suspense } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import Script from 'next/script';

const GA_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID || process.env.NEXT_PUBLIC_GA_ID;

function GAPageTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!GA_ID || typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    const url = pathname + (searchParams?.toString() ? `?${searchParams?.toString()}` : '');
    window.gtag('config', GA_ID, { page_path: url });
  }, [pathname, searchParams]);

  return null;
}

export default function GoogleAnalytics() {
  if (!GA_ID) return null;

  return (
    <>
      <Script data-component-id="src/components/GoogleAnalytics.tsx:26:6" data-component-path="src/components/GoogleAnalytics.tsx" data-component-line="26" data-component-end-line="29" data-component-file="GoogleAnalytics.tsx" data-component-name="Script" data-component-content="%7B%22elementName%22%3A%22Script%22%7D"
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`}
        strategy="afterInteractive"
      />
      <Script data-component-id="src/components/GoogleAnalytics.tsx:30:6" data-component-path="src/components/GoogleAnalytics.tsx" data-component-line="30" data-component-end-line="37" data-component-file="GoogleAnalytics.tsx" data-component-name="Script" data-component-content="%7B%22elementName%22%3A%22Script%22%2C%22id%22%3A%22google-analytics%22%7D" id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_ID}', { page_path: window.location.pathname });
        `}
      </Script>
      <Suspense fallback={null}>
        <GAPageTracker data-component-id="src/components/GoogleAnalytics.tsx:39:8" data-component-path="src/components/GoogleAnalytics.tsx" data-component-line="39" data-component-end-line="39" data-component-file="GoogleAnalytics.tsx" data-component-name="GAPageTracker" data-component-content="%7B%22elementName%22%3A%22GAPageTracker%22%7D" />
      </Suspense>
    </>
  );
}
